import {useState} from 'react';
import {useParams} from 'react-router-dom';

import {httpMonitorAPI} from 'features/http/api/httpMonitorAPI';
import {
    DEFAULT_HTTP_MONITOR_TAB,
    getHttpMonitorChartHeight,
    HttpMonitorTab,
    shouldShowHttpMonitorDetailsHeader,
} from 'features/http/lib/httpMonitorDetailsScreen';
import useBreakpoint from 'shared/lib/hooks/useBreakpoint';
import {getPollingInterval} from 'shared/api/pollingHelper';

import {IHttpMonitorItem} from './HttpMonitor/IHttpMonitor';

export interface IUseHttpMonitorDetailsScreen {
    monitor: IHttpMonitorItem | undefined,
    activeTab: HttpMonitorTab,
    setActiveTab: (_tab: HttpMonitorTab) => void,
    showHeader: boolean,
    chartHeight: number,
}

export const useHttpMonitorDetailsScreen = (): IUseHttpMonitorDetailsScreen => {
    const {monitorId} = useParams<{monitorId: string}>();
    const breakpoint = useBreakpoint();
    const [activeTab, setActiveTab] = useState<HttpMonitorTab>(DEFAULT_HTTP_MONITOR_TAB);

    const {data: monitor} = httpMonitorAPI.useGetHttpMonitorQuery(monitorId ?? '', {
        skip: !monitorId,
        pollingInterval: getPollingInterval(),
    });

    return {
        monitor,
        activeTab,
        setActiveTab,
        showHeader: shouldShowHttpMonitorDetailsHeader(breakpoint),
        chartHeight: getHttpMonitorChartHeight(breakpoint),
    };
};

export default useHttpMonitorDetailsScreen;
